module.exports = __webpack_public_path__ + "fonts/Alibaba-Rubik.071fcca9.ttf";